import { useState } from "react";
import { usePartnerAuth } from "../../../auth/PartnerAuthProvider";
import { PARTNER_WHATSAPP_EXPORT_ENABLED } from "../../../constants/partnerWhatsappMonitoringConstants";
import { canPartnerWhatsappExport } from "../../../utils/partnerWhatsappExport";

export default function PartnerWhatsappExportButton({
  label,
  onExport,
  disabled = false,
  className = "partner-dashboard-btn",
}) {
  const { partner } = usePartnerAuth();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  if (!PARTNER_WHATSAPP_EXPORT_ENABLED || !canPartnerWhatsappExport(partner)) {
    return null;
  }

  const handleClick = async () => {
    setLoading(true);
    setErrorMessage("");
    try {
      await onExport();
    } catch {
      setErrorMessage("We could not generate this report right now.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="partner-whatsapp-export">
      <button
        type="button"
        className={className}
        onClick={handleClick}
        disabled={disabled || loading}
      >
        {loading ? "Exporting…" : label}
      </button>
      {errorMessage ? <p className="admin-data-health-error">{errorMessage}</p> : null}
    </div>
  );
}
